import { render, staticRenderFns } from "./layar.vue?vue&type=template&id=e29c728a&"
import script from "./layar.vue?vue&type=script&lang=js&"
export * from "./layar.vue?vue&type=script&lang=js&"
import style0 from "./layar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports